import React, { Component } from "react";
import { Spinner } from "../common/spinner";
import Constants from "../../configurations/constants";
import ReportProgress from "./ReportProgress";

class GenerateForm extends Component {
  render() {
    const {
      generate,
      generating,
      showForm,
      progressList,
      getReportStatus,
      retry,
      deleteDownload,
      clearDownloads,
      download
    } = this.props;
    return (
      <div>
        {showForm ? (
          <div className="panel panel-default">
            <div className="panel-body">
              <strong>Generate Report as: </strong>
              {Constants.SETTLEMENT_REPORT_TYPES.map(type => (
                <button
                  key={type.value}
                  id="generateButton"
                  className="generate-btn"
                  style={{ backgroundColor: type.color }}
                  type="button"
                  onClick={() => generate(type.value)}
                  disabled={generating.length}
                >
                  {generating[type.value] ? (
                    <Spinner size="15px" />
                  ) : (
                    <span>
                      <type.icon size={15} /> {type.name}
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        ) : null}
        {progressList && progressList.length ? (
          <ReportProgress
            getReportStatus={getReportStatus}
            reports={progressList}
            deleteDownload={deleteDownload}
            retry={retry}
            clearDownloads={clearDownloads}
            download={download}
          />
        ) : null}
      </div>
    );
  }
}

export default GenerateForm;



// WEBPACK FOOTER //
// ./src/components/reports/GenerateForm.js